import type { CreativesConfigBreakpoints } from '@ad-lucy/config/creatives';

export const defaultBreakpoints: CreativesConfigBreakpoints = {
  sitebar: '(min-width: 550px)',
  hpa: '(max-width: 549px) and (min-height: 850px)',
  mobile: '(max-width: 549px) and (max-height: 849px)',
  mqHPA: '(max-width: 400px)',
  billboard:
    '(max-width: calc(100vh * (16 / 5) + 4px)) and (min-width: calc(100vh * (16 / 5) - 4px)) and (max-height: calc(100vw * (5 / 16) + 4px)) and (min-height: calc(100vw * (5 / 16) - 4px))',
};
